import { css } from '@linaria/core';
import theme from '../../../theme';

export const variants = {
  vertical: css``,
  info: css``,
  success: css``,
  warning: css``,
  error: css``,
};
export const components = {
  container: css``,
  title: css``,
  content: css``,
  btnClose: css``,
  icon: css``,
};

export const alert = css`
  border-left-width: 8px;
  font-size: 1rem;
  padding: 16px 24px;
  border-radius: 4px;
  gap: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
  background: var(--alert-content-color, ${theme.colors.peoople['azul-claro']});
  color: var(--alert-text-color, ${theme.colors.peoople['azul-claro-medio']});
  align-items: center;

  & .${components.container} {
    gap: 12px;
    flex-direction: column;
    align-items: flex-start;
    display: flex;
    flex: 1;

    @media (min-width: ${theme.sizes.screens.sm}) {
      flex-direction: row;
    }

    &.${variants.vertical} {
      flex-direction: column;
    }
  }

  & .${components.title} {
    font-weight: 600;
    gap: 12px;
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 24px;
  }

  & .${components.content} {
    width: 100%;
    font-weight: 600;
    font-size: 16px;
    white-space: normal;
    line-height: 24px;
  }

  & .${components.btnClose} {
    color: #ffffff;
  }

  & .${components.icon} {
    font-size: inherit;
  }

  &.${variants.info} {
  }

  &.${variants.success} {
    --alert-text-color: ${theme.colors.success['95']};
    --alert-content-color: ${theme.colors.success['50']};
  }

  &.${variants.warning} {
    --alert-text-color: ${theme.colors.warning['80']};
    --alert-content-color: ${theme.colors.warning['50']};
  }

  &.${variants.error} {
    --alert-text-color: ${theme.colors.error['95']};
    --alert-content-color: ${theme.colors.error['50']};
  }
`;
